import { Component, OnInit } from '@angular/core';
import { BlobFileDownloadRequestModel } from '../../../models/blob-file-sas-url.model';
import { SIDownloadCSV } from '../../../models/si-download-csv.model';
import { CommonSharedModule } from '../../common/shared.module';
import { ExportService } from '../../services/export.service';
import { SIDownloadReportService } from '../../services/si-download-report.service';
import { CsiEngagementMilestone2Component } from './csi-engagement-milestone2/csi-engagement-milestone2.component';

@Component({
  selector: 'app-si-download-csv',
  templateUrl: './si-download-csv.component.html',
  styleUrls: ['./si-download-csv.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, CsiEngagementMilestone2Component]
})
export class SIDownloadCsvComponent implements OnInit {
  downloadCSV!: SIDownloadCSV[];
  loadingIcon = 'fa-circle-o-notch';
  loading = false;
  selectedItem!: SIDownloadCSV;
  cols: any;
  excelLoadingReadyforPayment = false;
  excelLoadingNoPayeeID = false;

  constructor(
    private service: SIDownloadReportService,
    private exportService: ExportService
  ) {}

  ngOnInit() {
    this.getDownloadCSV();
    this.loading = true;
  }

  getDownloadCSV() {
    this.service.getSIDownloadCSVFilesList().subscribe(downloadReport => {
      this.downloadCSV = downloadReport;
      this.loading = false;
    });
  }

  downloadFile(selectedFile: SIDownloadCSV) {
    const blobFileDownloadRequestModel: BlobFileDownloadRequestModel = {
      fileName: selectedFile.fileName || '',
      fileUrl: selectedFile.url || ''
    };

    this.service
      .getSIDownloadCSVFile(blobFileDownloadRequestModel)
      .subscribe(downloadFileSasUrl => {
        window.location.href = downloadFileSasUrl;
      });
  }

  async exportReadyforPaymentReport() {
    this.excelLoadingReadyforPayment = true;
    await this.exportReport(true);
    this.excelLoadingReadyforPayment = false;
  }

  async exportNoPayeeIDPaymentReport() {
    this.excelLoadingNoPayeeID = true;
    await this.exportReport(false);
    this.excelLoadingNoPayeeID = false;
  }

  async exportReport(hasPayeeId: boolean) {
    const excelData = await this.service
      .getSIReadyforPaymentReport(hasPayeeId)
      .toPromise();

    if (excelData) {
      const name =
        hasPayeeId == true
          ? 'Ready For Payment'
          : 'No Payee ID Ready For Payment';
      this.exportService.exportExcel(excelData, name);
    }
  }
}
